import { CustomNode } from '../../../types';
import { sendPushIcon } from '../../../icons';

const DEFAULT_ICON = sendPushIcon;

export const sendPushConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
